import { Routes, Route } from 'react-router-dom';
import { ShowMySubscription } from './ShowMySubscription';

export const MySubscriptionRouter = () => (
  <Routes>
    <Route path="/details" element={<ShowMySubscription />} />
  </Routes>
);
